import * as pageTypes from "./types";
import { normalize } from "normalizr";
import { pageResultsSchema } from "../../schemas";
import { requestWithAuth, requestWithoutAuth } from "../../utils/request";
import { errorActionFactory } from "../../helpers/errors";
import * as apiHelper from "../../helpers/api";

const API_URL = apiHelper.getApiUrl();

function requestPageResults(pageId) {
    return {
        type: pageTypes.REQUEST_PAGE_RESULTS,
        pageId
    };
}

function pageResultsSuccess(pageId, entities) {
    return {
        type: pageTypes.PAGE_RESULTS_SUCCESS,
        pageId,
        entities
    };
}

export function fetchPageResults(wevoId, pageId) {
    return dispatch => {
        dispatch(requestPageResults(pageId));
        return requestWithAuth(dispatch, http =>
            http.get(`${API_URL}/wevos/${wevoId}/pages/${pageId}/results`)
        )
            .then(({ data }) => {
                const { entities } = normalize(data, pageResultsSchema);
                return dispatch(pageResultsSuccess(pageId, entities));
            })
            .catch(err =>
                dispatch(errorActionFactory(pageTypes.PAGE_RESULTS_ERROR, err))
            );
    };
}

export function fetchPageResultsByShareLink(shareLinkId, pageId) {
    return dispatch => {
        dispatch(requestPageResults(shareLinkId, pageId));
        return requestWithoutAuth(dispatch, http =>
            http.get(
                `${API_URL}/wevoShareLinks/${shareLinkId}/pages/${pageId}/results`
            )
        )
            .then(({ data }) => {
                const { entities } = normalize(data, pageResultsSchema);
                return dispatch(pageResultsSuccess(pageId, entities));
            })
            .catch(err =>
                dispatch(errorActionFactory(pageTypes.PAGE_RESULTS_ERROR, err))
            );
    };
}



// WEBPACK FOOTER //
// ./src/modules/pages/actions.js